<template>
    <bc-tooltip v-if="show_button">
        <template slot="activator">
            <v-btn icon @mouseup.left="$emit('invoke-method')">
                <v-icon class="hover-red-icon">delete_outline</v-icon>
            </v-btn>
        </template>
        {{ $t('lang.delete_all') }}
    </bc-tooltip>
</template>


<script>
export default {
    props: {
        perm: {
            type: String,
            default: null
        },
        loginType: {
            type: String,
            default: null
        },
    },
    computed: {
        show_button(){
            return (!this.perm || this.hasPerm(this.perm)) && (!this.loginType || this.currUserField('slug') == this.loginType);
        }
    }
}
</script>